import _jsx from "@babel/runtime/helpers/jsx";
import PropTypes from 'prop-types';
import React from 'react';
import clsx from 'clsx';
import { Button, Glyphicon, GlyphiconStack } from 'reaxl';

/**
 *  The SaveGlyph leverages the GlyphiconStack component to display
 *  the heart icon in both the saved and unsaved states
 *
 */
// vdp_mobile_lead_cta_relocation cleanup: This component needs to be made more generic,
// also update elot-web-component (https://ghe.coxautoinc.com/Autotrader/elot-web-component)
function SaveGlyph(_ref) {
  let {
    brand,
    isSaved,
    onClick,
    className,
    action = 'save',
    uiContext = 'default',
    ...rest
  } = _ref;
  const glyphMap = {
    save: 'heart',
    share: 'share'
  };
  const glyph = glyphMap[action] || 'heart';
  return /*#__PURE__*/_jsx(Button
  // Capitalize first letter of the action
  , {
    "aria-label": `${action.replace(/^./, action[0].toUpperCase())} vehicle`,
    onClick: onClick,
    className: clsx('display-inline-block', 'save-glyph-background', {
      'save-glyph-background-circle': uiContext === 'accent-circle'
    }),
    bsStyle: "text"
  }, void 0, /*#__PURE__*/React.createElement(GlyphiconStack, Object.assign({
    "data-cmp": `${action}Glyph`,
    className: clsx({
      'text-gray-base': uiContext === 'inverse',
      'text-inverse': uiContext !== 'inverse' && uiContext !== 'accent-circle',
      'save-glyph-interactive': uiContext === 'accent-circle' // on click: scale inner glyph down and up
    }, 'save-glyph', className),
    resize: false
  }, rest), /*#__PURE__*/_jsx(Glyphicon, {
    glyph: glyph,
    className: clsx({
      'text-saved': isSaved,
      transparent: !isSaved
    })
  }), /*#__PURE__*/_jsx(Glyphicon, {
    glyph: `${glyph}${glyph === 'heart' ? '-o' : ''}`,
    className: clsx({
      'text-inverse': uiContext === 'inverse',
      'text-subdued': uiContext === 'default' || !uiContext,
      'text-accent': (uiContext === 'accent' || uiContext === 'accent-circle') && (brand !== 'kbb' || brand === 'kbb' && !isSaved),
      'text-saved': isSaved && brand === 'kbb'
    })
  })));
}
export default SaveGlyph;